import React, { useState } from 'react';

export const VisitasPilares = ({ infoCompany, function_url }) => {
    const warrantyData = infoCompany?.view_waranty || [];

    const [hoveredStates, setHoveredStates] = useState([false, false, false, false]);

    const handleHover = (index, isHovered) => {
        setHoveredStates(prev => {
            const newState = [...prev];
            newState[index] = isHovered;
            return newState;
        });
    };

    return (
        <div>
            <div className="container-pill">
                <h2>GARANTÍA DE NUESTROS PRODUCTOS</h2>
                <div className="container-dots">
                    <div className="circle-one" />
                    <div className="circle-two" />
                    <div className="circle-three" />
                    <div className="circle-four" />
                </div>
                <div className="container-pill-subtitle">
                    Es un compromiso formal, generalmente ofrecido por el fabricante
                    o el vendedor, que asegura al comprador que el
                    producto cumplirá con ciertas condiciones de calidad,
                    funcionalidad y durabilidad durante un periodo de tiempo específico.
                </div>

                <div className="pills-container">
                    {warrantyData.map((content, index) => {
                        const isTop = index % 2 === 0;
                        const isHovered = hoveredStates[index];

                        // Determinar el gradiente y color de texto por pilar
                        const gradients = [
                            'linear-gradient(90deg, rgba(1,94,234,1) 0%, rgba(0,192,250,1) 100%)',
                            'linear-gradient(90deg, rgba(250,204,34,1) 0%, rgba(248,54,0,1) 100%)',
                            'linear-gradient(103deg, rgba(124,2,248,1) 59%, rgba(183,1,248,1) 78%)',
                            'linear-gradient(103deg, rgba(86,196,0,1) 32%, rgba(239,230,23,1) 78%)'
                        ];

                        const colorTexts = [
                            "Nuestros Empleados",
                            "Calidad Garantizada",
                            "Atencion Personalizada",
                            "Cobertura Nacional"
                        ];

                        return (
                            <div
                                key={index}
                                className={`pill ${isHovered ? 'hovered' : ''} ${isTop ? 'top' : 'bottom'}`}
                                onMouseEnter={() => handleHover(index, true)}
                                onMouseLeave={() => handleHover(index, false)}
                            >
                                <div
                                    className="colored-section"
                                    style={{ background: gradients[index] }}
                                ></div>

                                <div className={`circle-wrapper ${isHovered ? 'hovered' : ''}`}>
                                    <div className="circle">
                                        <div className="image-container">
                                            <img
                                                src={function_url(content?.img_url == 'null' ? null : content?.img_url, "picture")}
                                                alt={`Pilar ${index + 1}`}
                                                style={{ width: '100%', height: '100%', objectFit: 'fill' }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="text-container">
                                    <div className={`text-title ${isHovered ? 'hovered' : ''}`}>
                                        {content?.title??colorTexts[index]} {/* Título específico por pilar */}
                                    </div>
                                    <div className={`content ${isHovered ? 'hovered' : ''}`}>
                                        {content.text} {/* Texto desde la API */}
                                    </div>
                                </div>

                                <div
                                    className="number-wrapper"
                                    style={{ background: gradients[index] }}
                                >
                                    <div className="inner-number">
                                        {String(index + 1).padStart(2, '0')} {/* 01, 02, 03, 04 */}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
